// Baseline Screen - Full-Width Responsive Layout
import { useApp } from '../hooks/useApp';
import { Container, Text, Card, Button, IconButton } from '../components/ui';
import Icons from '../components/Icons';
import BottomNav from '../components/BottomNav';

function BaselineScreen() {
    const { goBack, baselineData, showToast } = useApp();

    const daysOfWeek = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'];
    const today = new Date().getDate();
    const calendarDays = Array.from({ length: 7 }, (_, i) => today - 3 + i);
    const completedDays = baselineData.data.map(d => new Date(d.date).getDate());

    return (
        <Container className="min-h-screen bg-theme-bg pb-24" safe>
            <div className="header-fullwidth">
                <div className="header-content">
                    <IconButton onClick={goBack}><Icons.Back /></IconButton>
                    <Text className="font-semibold sm:text-lg">Baseline Cá Nhân</Text>
                    <div className="w-11" />
                </div>
            </div>

            <div className="main-content py-4 sm:py-6">
                {/* Info */}
                <div className="text-center py-6 mb-6">
                    <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center">
                        <Icons.Baseline />
                    </div>
                    <Text variant="h3" className="mb-2">Baseline là gì?</Text>
                    <Text variant="caption" className="max-w-xs mx-auto leading-relaxed">
                        Baseline là "chỉ số gốc" cá nhân của bạn, được xây dựng từ 7 ngày liên tục để AI hiểu rõ tình trạng sức khỏe bình thường của bạn.
                    </Text>
                </div>

                {/* Progress */}
                <Card className="mb-6">
                    <div className="flex items-center justify-between mb-4">
                        <Text className="font-semibold">Tiến độ</Text>
                        <span className={`px-3 py-1 rounded-full text-xs font-semibold ${baselineData.established ? 'bg-success/20 text-success' : 'bg-warning/20 text-warning'}`}>
                            {baselineData.daysCompleted}/{baselineData.totalDays} ngày
                        </span>
                    </div>
                    <div className="h-2 bg-theme-tertiary rounded-full overflow-hidden mb-4">
                        <div
                            className="h-full bg-gradient-to-r from-primary to-success transition-all"
                            style={{ width: `${(baselineData.daysCompleted / baselineData.totalDays) * 100}%` }}
                        />
                    </div>
                    <Text variant="caption" className="text-center">
                        {baselineData.established
                            ? '✅ Baseline đã hoàn thành!'
                            : `Còn ${baselineData.totalDays - baselineData.daysCompleted} ngày nữa`}
                    </Text>
                </Card>

                {/* Calendar */}
                <Card className="mb-6">
                    <Text className="font-semibold mb-4">Lịch ghi nhận</Text>
                    <div className="grid grid-cols-7 gap-2 mb-2">
                        {daysOfWeek.map(day => (
                            <div key={day} className="text-center text-xs text-text-tertiary">{day}</div>
                        ))}
                    </div>
                    <div className="grid grid-cols-7 gap-2">
                        {calendarDays.map(day => (
                            <div
                                key={day}
                                className={`
                  aspect-square flex items-center justify-center rounded-xl text-sm font-medium relative
                  ${day === today ? 'bg-theme-tertiary text-white' : ''}
                  ${completedDays.includes(day) ? 'bg-success/20 text-success' : 'text-text-secondary'}
                `}
                            >
                                {day}
                                {completedDays.includes(day) && (
                                    <div className="absolute bottom-1 w-1.5 h-1.5 rounded-full bg-success" />
                                )}
                            </div>
                        ))}
                    </div>
                </Card>

                <Button className="w-full" onClick={() => showToast('Tính năng sẽ được cập nhật', 'info')}>
                    <Icons.Camera />
                    Chụp ảnh hôm nay
                </Button>
            </div>

            <BottomNav />
        </Container>
    );
}

export default BaselineScreen;
